class OtpMapper {
  static createFromResponse(response) {
    var _response$verificatio, _response$retry_attem, _response$next_retry_;
    return {
      verificationResult: (_response$verificatio = response.verification_result) !== null && _response$verificatio !== void 0 ? _response$verificatio : undefined,
      retryAttempts: (_response$retry_attem = response.retry_attempts) !== null && _response$retry_attem !== void 0 ? _response$retry_attem : undefined,
      nextRetryInMs: (_response$next_retry_ = response.next_retry_in_ms) !== null && _response$next_retry_ !== void 0 ? _response$next_retry_ : undefined
    };
  }
}

export { OtpMapper };
//# sourceMappingURL=OtpMapper.js.map
